import { useParams } from "react-router-dom";
import SeoPageLayout from "@/components/SeoPageLayout";
import NotFound from "@/pages/NotFound";
import { sectorBySlug } from "@/data/sectors";

export default function SectorDetail() {
  const { slug } = useParams();
  const entry = sectorBySlug(slug);
  if (!entry) return <NotFound />;

  return (
    <SeoPageLayout
      entry={entry}
      eyebrow="Sector"
      schemaType="Service"
      testid={`page-sector-${entry.slug}`}
      breadcrumb={[
        { name: "Home", path: "/" },
        { name: "Voor wie", path: "/voor-wie" },
        { name: entry.navLabel, path: entry.to },
      ]}
    />
  );
}
